export default __webpack_public_path__ + "static/media/drop-image.2fb3b9dc.svg";